<app-cms-top-bar></app-cms-top-bar>
<div id="wrapper">
    <app-cms-side-bar [active]="'user-management'"></app-cms-side-bar>
    <div id="content-wrapper">

        <div class="container-fluid">
            <p class="title">แก้ไขผู้ใช้งาน</p>

            <!-- Form  -->
            <div class="card mb-3">
                <div class="card-body p-3">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label for="">เลขบัตรประชาชน<a style="color: red;">*</a></label>
                                    <input type="number" class="form-control" placeholder="กรอกเลขบัตรประชาชน" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="13"
                                        [(ngModel)]="username" required >
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label for="">Password<a style="color: red;">*</a></label>
                                    <input type="password" class="form-control" placeholder="กรอก Password"
                                    [(ngModel)]="password" required >
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="">Email address<a style="color: red;">*</a></label>
                                    <input type="email" class="form-control" placeholder="กรอก Email"
                                    [(ngModel)]="eMail" required>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <label for="">คำนำหน้า</label>
                                <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example"
                                [(ngModel)]="prefix">
                                    <option selected disabled hidden>คำนำหน้า</option>
                                    <option value="นาย">นาย</option>
                                    <option value="นาง">นาง</option>
                                    <option value="นางสาว">นางสาว</option>
                                </select>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="">ชื่อจริง</label>
                                    <input type="text" class="form-control" placeholder="กรอก ชื่อจริง"
                                    [(ngModel)]="fName">
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <div class="form-group">
                                    <label for="">นามสกุล</label>
                                    <input type="text" class="form-control" placeholder="กรอก นามสกุล"
                                    [(ngModel)]="lName">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2">
                                <label for="">สิทธิ์การใช้งาน<a style="color: red;">*</a></label>
                                <select class="form-select" aria-label="Default select example" [(ngModel)]="role"
                                    (change)="get_role($event.target.value)" required>
                                    <option selected disabled hidden>สิทธิ์การใช้งาน</option>
                                    <option value="Admin">Admin</option>
                                    <option value="Executive">ผู้บริหารกรม</option>
                                    <option value="Central_agency">หน่วยงานส่วนกลาง</option>
                                    <option value="District_inspector">ผู้ตรวจการเขต</option>
                                    <option value="Provincial_officials">ส่วนจังหวัด</option>
                                    <option value="Officer">พนักงาน</option>
                                </select>
                            </div>
                            <div class="col-md-2" *ngIf="role == 'District_inspector'">
                                <label for="">หน่วยงาน</label>
                                <button type="button" class="btn btn-primary btn-sm" data-toggle="modal"
                                    data-target="#selectKhet" style="width: 76px; height: 39.6px;">เลือกเขต</button>
                            </div>
                            <div class="col-lg-3" *ngIf="role == 'Provincial_officials'">
                                <label for="">หน่วยงาน</label>
                                <select class="form-select" aria-label="Default select example" [(ngModel)]="institution_data">
                                    <option selected disabled hidden>หน่วยงาน</option>
                                    <option *ngFor="let list of institution_province" value="{{list.orgOrgId}}">
                                        {{list.orgName}}</option>
                                </select>
                            </div>
                            <div class="col-lg-3" *ngIf="role == 'Central_agency'">
                                <label for="">หน่วยงานส่วนกลาง</label>
                                <select class="form-select" aria-label="Default select example" [(ngModel)]="select_center_data">
                                    <option selected disabled hidden>หน่วยงาน</option>
                                    <option *ngFor="let list of center_data" value="{{list.id}}">
                                        {{list.agency}}</option>
                                </select>
                            </div>
                            <div class="col-lg-4">
                                <div class="form-group">
                                    <label for="">เบอร์โทร</label>
                                    <input type="text" class="form-control" placeholder="กรอกเบอร์โทร" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="10"
                                    [(ngModel)]="tel">
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="warning == true">
                            <div class="col">
                                <p style="text-align: center; color: red;">กรุณากรอกข้อมูลให้ครบทุกช่อง</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="text-right">
                                <button type="button" class="btn btn-danger btn-sty" style="margin-right: 5px;" (click)="cancle()">ยกเลิก</button>
                                <button type="button" class="btn btn-success btn-sty"
                                    style="margin-right: 3px;" (click)="update_user()">บันทึก</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="selectKhet" tabindex="-1" role="dialog"
                aria-labelledby="selectKhetTitle" aria-hidden="true">
                <div class="modal-dialog" role="document" >
                    <div class="modal-content" style="width: 110% !important;">
                        <div class="modal-header">
                            <h5 class="modal-title" id="selectKhetTitle">เลือกเขต</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="width: 10%;">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" style="overflow-y: auto;">
                                <div class="col-lg-6">
                                    <table class="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th>ชื่อเขต</th>
                                                <th>ตัวเลือก</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let list of institution_khet_arr1">
                                                <td>
                                                    <label for="{{list.khetId}}"> {{list.khetDesc}}</label>
                                                </td>
                                                <td *ngIf="list.isCheck == true">
                                                    <input type="checkbox" id="{{list.khetId}}" value="{{list.khetId}}" (change)="get_khet_select($event.target.value)" checked>
                                                </td>
                                                <td *ngIf="list.isCheck == false">
                                                    <input type="checkbox" id="{{list.khetId}}" value="{{list.khetId}}" (change)="get_khet_select($event.target.value)">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-lg-6">
                                    <table class="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th>ชื่อเขต</th>
                                                <th>ตัวเลือก</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let list of institution_khet_arr2">
                                                <td>
                                                    <label for="{{list.khetId}}"> {{list.khetDesc}}</label>
                                                </td>
                                                <td *ngIf="list.isCheck == true">
                                                    <input type="checkbox" id="{{list.khetId}}" value="{{list.khetId}}" (change)="get_khet_select($event.target.value)" checked>
                                                </td>
                                                <td *ngIf="list.isCheck == false">
                                                    <input type="checkbox" id="{{list.khetId}}" value="{{list.khetId}}" (change)="get_khet_select($event.target.value)">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sty" data-dismiss="modal" >ตกลง</button>
                        </div>
                    </div>
                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>
